import React from 'react'
import PropTypes from 'prop-types'
import { Menu, MenuButton, MenuItem, MenuDropdown } from './Shared'
import { toUpper } from 'lodash'

const VMSubMenu = ({ vm }) => (
  <Menu>
    <MenuButton text={toUpper(vm.name)} textToCopy={vm.name} label={vm.label} />
    <MenuDropdown>
      <MenuItem text={'Datto Summary'} href={vm.dattoSummaryUrl} />
      <MenuItem text={'Open remote session'} href={vm.dattoRemoteUrl} />
    </MenuDropdown>
  </Menu>
)

export default VMSubMenu
